/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ImportSourceFormat } from '../model/importSourceFormat';
// @ts-ignore
import { ParkerClassification } from '../model/parkerClassification';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class ParkingRightImportService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param apply 
     * @param source 
     * @param classification 
     * @param defaultParkingTypeId 
     * @param defaultSpaceId 
     * @param defaultZoneIds 
     * @param defaultZoneId 
     * @param defaultOrganizationId 
     * @param operatorId 
     * @param maxConcurrentCars 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public parkingrightsImportCsvPost(apply?: boolean, source?: ImportSourceFormat, classification?: ParkerClassification, defaultParkingTypeId?: string, defaultSpaceId?: string, defaultZoneIds?: Array<string>, defaultZoneId?: string, defaultOrganizationId?: string, operatorId?: string, maxConcurrentCars?: number, file?: Blob, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public parkingrightsImportCsvPost(apply?: boolean, source?: ImportSourceFormat, classification?: ParkerClassification, defaultParkingTypeId?: string, defaultSpaceId?: string, defaultZoneIds?: Array<string>, defaultZoneId?: string, defaultOrganizationId?: string, operatorId?: string, maxConcurrentCars?: number, file?: Blob, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public parkingrightsImportCsvPost(apply?: boolean, source?: ImportSourceFormat, classification?: ParkerClassification, defaultParkingTypeId?: string, defaultSpaceId?: string, defaultZoneIds?: Array<string>, defaultZoneId?: string, defaultOrganizationId?: string, operatorId?: string, maxConcurrentCars?: number, file?: Blob, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public parkingrightsImportCsvPost(apply?: boolean, source?: ImportSourceFormat, classification?: ParkerClassification, defaultParkingTypeId?: string, defaultSpaceId?: string, defaultZoneIds?: Array<string>, defaultZoneId?: string, defaultOrganizationId?: string, operatorId?: string, maxConcurrentCars?: number, file?: Blob, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>apply, 'apply');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>source, 'source');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>classification, 'classification');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>defaultParkingTypeId, 'defaultParkingTypeId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>defaultSpaceId, 'defaultSpaceId');
        if (defaultZoneIds) {
            defaultZoneIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'defaultZoneIds');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>defaultZoneId, 'defaultZoneId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>defaultOrganizationId, 'defaultOrganizationId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>operatorId, 'operatorId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>maxConcurrentCars, 'maxConcurrentCars');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (oauth2) required
        localVarHeaders = this.configuration.addCredentialToHeaders('oauth2', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (file !== undefined) {
            localVarFormParams = localVarFormParams.append('file', <any>file) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/parkingrights/import/csv`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
